import { VuexModule, Module, Mutation, Action, getModule } from 'vuex-module-decorators'
import store from '@/store'
import { ChatType } from '@/utils/const'


@Module({ dynamic: true, store, name: 'chat' })
class Chat extends VuexModule {
  public chatType = ChatType.ToRobot

  @Mutation
  private SET_CHAT_TYPE (type: ChatType) {
    this.chatType = type
  }

  @Action
  public setChatType (type: ChatType) {
    this.SET_CHAT_TYPE(type)
  }
}

export const ChatModule = getModule(Chat)